import axios from 'axios';

const cjPontanegraApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default cjPontanegraApi;
